import i18n from 'i18n-js';

import { LINK_STATUS } from '@helpers';
import type { LinkStatusInput, LinkStatusContent } from '@components/search/operations/components/StartJobPopup/types';

// Maps the link status to what should be rendered — pure logic, no JSX.
export const resolveLinkStatusContent = ({ status, error }: LinkStatusInput): LinkStatusContent => {
  switch (status) {
    case LINK_STATUS.Linking:
      return { label: i18n.t('Linking...'), color: 'Label/Light/Tertiary' };
    // LINK_STATUS.Linked has no inline state — success fires a toast and redirects (useManageStartJobPopup.handleLinked).
    case LINK_STATUS.Error:
      return { label: error || i18n.t('Failed to link NC program'), color: 'Label/Light/Warning' };
    default:
      return null;
  }
};
